<div class="page-layout simple fullwidth">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <h2>PERFIL</h2>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="center p-24 pb-56" fusePerfectScrollbar>
        <div class="content">
            <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
                <mat-tab-group dynamicHeight="true" *ngIf="!!(perfil$ | async)">
                    <mat-tab label="Identificación y roles">
                        <div class="p-24">
                            <app-ficha
                                [perfilUsuario]="perfil$ | async"
                                [tokenData]="tokenData"
                            ></app-ficha>
                        </div>
                    </mat-tab>
                    <mat-tab label="Notificaciones">
                        <app-notificaciones
                            [perfilUsuario]="perfil$ | async"
                            (guardaConfNotificaciones)="
                                guardarNotificaciones($event)
                            "
                        ></app-notificaciones>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
    <!-- / CONTENT -->
</div>
